import React, { useState, useEffect } from "react"
import styled from "styled-components"

const Tile = styled.div`
	width: 100%;
	display: grid;
	grid-gap: 20px;

	grid-template-rows: repeat(
		${(props) => Math.ceil(props.itemsToRender?.length / props.l)},
		${(props) => props.buttonSize || 148}px
	);

	grid-template-columns: repeat(
		${(props) => Math.ceil(props.itemsToRender?.length / Math.ceil(props.itemsToRender?.length / props.l))},
		${(props) => props.buttonSize || 148}px
	);

	grid-auto-flow: row;
	justify-content: center;
	opacity: ${(props) => (props.mounted ? 1 : 0)};
	transition: all 300ms ease-in-out;

	& > button {
		margin: 0 !important;
	}

	@media only screen and (max-width: 600px) {
		grid-template-rows: repeat(
			${(props) => Math.ceil(props.itemsToRender?.length / props.l)},
			${(props) => props.buttonSize || 148}px
		);

		grid-template-columns: repeat(
			${(props) => (props.itemsToRender?.length < 2 ? 1 : 2)},
			${(props) => props.buttonSize || 148}px
		);
	}
`

const TileGrid = ({ items, maxRowLength, buttonSize, itemWidth, children }) => {
	const [mounted, setMounted] = useState(false)

	const [id, setId] = useState(Math.random() * 1354345)
	const [l, setL] = useState(0)

	const itemsToRender = items ? items : children

	const getDimensions = () => {
		const { width } = document.getElementById(String(id))?.getBoundingClientRect()
		const l = Math.floor(width / itemWidth)

		return { l }
	}

	useEffect(() => {
		const { l } = getDimensions()
		setL(l)
		setTimeout(() => setMounted(true), 1)
	}, [itemsToRender?.length])

	return (
		<Tile
			id={id}
			l={l}
			itemsToRender={itemsToRender}
			maxRowLength={maxRowLength}
			mounted={mounted}
			buttonSize={buttonSize}
		>
			{itemsToRender?.map((itemsInLayout) => itemsInLayout)}
		</Tile>
	)
}

export default TileGrid
